import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// `cn` is a short form of ClassName, which is widely used in others tailwind projects
// See: https://ui.shadcn.com/docs/installation/manual#add-a-cn-helper
// eslint-disable-next-line import/prefer-default-export
export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
